import React from 'react'
import bg from './assets/stars.svg'
import doge from './assets/doge.png'
import { IoDocument } from 'react-icons/io5'
import { FaEthereum, FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa'

const Main: React.FC = () => {

    const awards = [
        {
            award: '🥇 Best Hack |🏆 Best UI Hack',
            url: 'https://devfolio.co/submissions/plug-and-pay-crypto-api-axion-a7bc'
        },
        {
            award: '🥈 Best Sustainable Hack - Runner Up',
            url: 'https://devfolio.co/submissions/karbonize-d863'
        },
        {
            award: '🥉 Best Individual Hack - 2nd Runner Up',
            url: 'https://devfolio.co/submissions/vybe-8201'
        },
        {
            award: '🥈 Best Fintech Hack - Runner Up',
            url: 'https://devfolio.co/submissions/cryptify-78c9'
        }
    ]

    const skills = [
        'React Js + Typescript',
        'Solidity + Ethereum + HardHat',
        'Node Js + Express Js',
        'Mongo DB, Supabase, Firebase',
        'AWS, Heroku, Git, Jenkins, Python'
    ]

    return(
        <div className="h-screen w-screen overflow-y-auto opacity-95" style={{backgroundImage:`url(${bg})`}}>
            <style>
                @import url('https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap');
            </style>
            <div style={{fontFamily:"'Roboto Mono', monospace"}} className="flex text-gray-100 justify-center h-full md:px-16 py-4 px-8">
                <div className="space-y-8">
                    <nav className="lg:flex items-center justify-between space-y-2">
                        <a href="/" target="_blank" rel="noopener" className="space-x-1 hover:underline flex items-center">
                            <IoDocument className="text-xl"/>
                            <p>Resume</p>
                        </a>
                        <a href="https://github.com/AL-S4H3R" target="_blank" rel="noopener" className="space-x-1 hover:underline flex items-center">
                            <FaGithub className="text-xl"/>
                            <p>Github</p>
                        </a>
                        <a href="https://www.linkedin.com/in/shlok-mange-508b53117/" target="_blank" rel="noopener" className="space-x-1 hover:underline flex items-center">
                            <FaLinkedin className="text-xl text-blue-800"/>
                            <p>in/shlok-mange</p>
                        </a>
                        <a href="https://twitter.com/shlokm289" target="_blank" rel="noopener" className="space-x-1 hover:underline flex items-center">
                            <FaTwitter className="text-xl text-blue-400"/>
                            <p>@shlokm289</p>
                        </a>
                    </nav>
                    <div className="flex justify-center animate-pulse">
                        <img src={doge} alt="" className="h-24 w-24"/>
                    </div>
                    <div className="space-y-4">
                        <h1 className="text-5xl italic tracking-wider font-bold text-center">hi, i'm Shlok</h1>
                        <h2 className="text-center text-indigo-500 text-xl font-bold">Founder & CEO | Cryptify</h2>
                        <div className="flex justify-center">
                            <div className="space-y-1">
                                <p className="text-gray-200 text-xl text-center">Product Developer moonlighting as an electronics engineer 📡.</p>
                                <p className="text-gray-400 text-center flex items-center justify-center">Super bullish on web3 🚀, love to build apps on ETH <span className="hidden lg:block"><FaEthereum/></span></p>
                            </div>
                        </div>
                    </div>
                    <div className="md:flex justify-center md:space-x-8 space-y-8 md:space-y-0">
                        <div className="space-y-2">
                            <h1 className="text-3xl text-center text-green-500 font-bold">
                                Hackathon Awards 🤑:
                            </h1>
                            <ul className="space-y-1">
                                {
                                    awards.map((award, index) => {
                                        return(
                                            <li className="px-2 text-center">
                                                <a className="hover:underline hover:text-blue-900" href={award.url}>{` ${award.award}`}</a>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <div>
                            <h1 className="text-3xl  text-blue-500 font-bold">Stuff i know 🔥:</h1>
                            <ul className="text-start">
                                {
                                    skills.map((skill, index) => {
                                        return(<li key={index}>✔️ {skill}</li>)
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                    <footer className="text-center tracking-widest text-indigo-200" style={{fontFamily:"'Indie Flower', cursive"}}>
                        Made with 🖤 by yours truly. 
                    </footer>
                </div>
            </div>
        </div>
    )
}

export default Main